import instance from './base.service';

export const vehicleInfo = async (params) => {
  try {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    return await instance.get(`/vehicle${queryString}`);
  } catch (error) {
    console.log(error);
  }
};
